import { Alert, Button } from 'antd';
import type { RoleAccess } from '../utils/roleAccess';

/** Shown to a customer role manager when their company list couldn't be loaded. */
export const IdentityErrorAlert: React.FC<{ access: RoleAccess }> = ({ access }) =>
  access.identityError ? (
    <Alert
      type="error"
      showIcon
      style={{ marginBottom: 16 }}
      message="Couldn't load which companies you can manage"
      description="Changes are off until it loads."
      action={
        <Button size="small" onClick={access.retryIdentity}>
          Try again
        </Button>
      }
    />
  ) : null;
